import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { useAuth } from "../../contexts/AuthContext";
import { PROBLEM_CARDS, PROBLEM_LEAD } from "./homeContent";
import { Body, H2, H3, Inner, Kicker, Lead, Section, alpha, useHomeTokens } from "./primitives";

/**
 * #problem — "The disconnect": you are building someone else's asset.
 *
 * The investment sentence and the "Invest in the platform" card are member-only
 * (see the note at the top of homeContent.ts). Logged out, the last remaining
 * card takes the accent so the grid keeps its shape.
 */
export const Problem = () => {
  const t = useHomeTokens();
  const { isAuthenticated } = useAuth();
  const cards = PROBLEM_CARDS.filter((card) => isAuthenticated || !card.memberOnly);
  return (
    <Section id="problem" alt>
      <Inner>
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap="28px" alignItems="start">
          <Flex direction="column" gap="20px" pr={{ lg: "20px" }}>
            <Kicker>The disconnect</Kicker>
            <H2>You are building someone else's asset</H2>
            <Lead>
              Traditional SaaS platforms own your data, train their AI on your business, and lock you into their
              ecosystem. You build their value while paying subscription fees forever.
            </Lead>
            <Lead>{isAuthenticated ? PROBLEM_LEAD.member : PROBLEM_LEAD.public}</Lead>
          </Flex>
          <Box display="grid" gap="14px">
            {cards.map((card, i) => {
              const highlight = card.highlight || (!isAuthenticated && i === cards.length - 1);
              return (
              <Box
                key={card.title}
                p="24px 26px"
                borderRadius="16px"
                borderWidth="1px"
                borderColor={highlight ? t.primaryBorder : t.cardBorder}
                bg={
                  highlight
                    ? `linear-gradient(135deg, ${alpha(t.primary, 0.1)} 0%, ${alpha(t.bg, 0.6)} 100%)`
                    : t.cardGradient
                }
                minW={0}
              >
                <H3 fontSize="1.05rem" mb="7px" color={highlight ? t.kicker : t.text}>
                  {card.title}
                </H3>
                <Body>{card.body}</Body>
              </Box>
              );
            })}
          </Box>
        </SimpleGrid>
      </Inner>
    </Section>
  );
};
